import "./index.scss";
import React from "react";

import { money } from "../atoms";

// One raise on offer. It is a choice among a few, so it reads as a selectable
// chip rather than as several competing primary buttons.
const BiddingPrice = ({ price, selected, onClick, disabled }) => (
  <button
    type="button"
    className={`bid-step ${selected ? "selected" : ""}`}
    onClick={onClick}
    disabled={disabled}
    aria-pressed={Boolean(selected)}
  >
    <span className="bid-step-plus">+</span>
    {money(price)}
  </button>
);

export default BiddingPrice;
